import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-clock",
  "use": "icon-clock-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-clock\"><path fill=\"currentColor\" d=\"M512.256 977.6a465.344 465.344 0 1 1 0-930.688 465.344 465.344 0 0 1 0 930.688z m38.784-465.28v-252.16a58.176 58.176 0 1 0-116.352 0v303.808c0 35.712 28.928 64.64 64.64 64.64h264.96a58.176 58.176 0 0 0 0-116.352H551.04z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol